import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const FilterItem = styled.TouchableOpacity`
  flex-direction: row;
  padding: ${RFValue(16)}px 0;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border2};
`;

export const FilterItemRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const FilterItemInfo = styled.View`
  flex: 1;
`;

export const FilterItemText = styled.Text<{active?: boolean}>`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.blue};
`;

export const FilterItemIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.text_dark};
  margin-left: ${RFValue(12)}px;
`;
